import { render, staticRenderFns } from "./KnowMore.vue?vue&type=template&id=141b6a7a&scoped=true&"
import script from "./KnowMore.vue?vue&type=script&lang=js&"
export * from "./KnowMore.vue?vue&type=script&lang=js&"
import style0 from "./KnowMore.vue?vue&type=style&index=0&id=141b6a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141b6a7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
